import { EstateSorter } from "@/components/hlidaci-pes/EstateSorter";
import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { useLanguage } from "@/context/LanguageContext";
import { WatchDogDateRangeFilter } from "@/components/hlidaci-pes/watchdog-page/WatchDogDateRangeFilter";

export function WatchDogResultsAnalyticsPanel() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      results: "Výsledky hlídacího psa",
    },
    en: {
      results: "Watchdog results",
    },
  }[language];

  return (
    <div className="space-y-3">
      <div className="same-line w-full sm:justify-between">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.results}
        </PortfolioPageSectionBadge>
        <div className="ml-auto flex w-full justify-end sm:w-auto">
          <EstateSorter />
        </div>
      </div>
      <WatchDogDateRangeFilter />
    </div>
  );
}
